<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import Grid from '../Shared/Grid'
export default {
  name: 'CourseManagers',
  props: ['courseId'],
  components: {
    Grid
  },
  mounted () {
  },
  data () {
    return {
      filterable: true,
      module: this.$route.meta.module,
      columnOptions: [
        { field: (col) => col.USER.USER_FIRST_NAME, name: 'USER_FIRST_NAME', label: 'First Name', sortable: true, filter: '', type: 'string' },
        { field: (col) => col.USER.USER_LAST_NAME, name: 'USER_LAST_NAME', label: 'Last Name', sortable: true, filter: '', type: 'string' },
        { field: (col) => col.USER.USER_EMAIL, name: 'USER_EMAIL', label: 'Email', sortable: true, filter: '', type: 'string' },
        { field: (col) => col.ACTIVE_IND, name: 'ACTIVE_IND', label: 'Manager Status', sortable: true, filter: '', type: 'string' }
      ],
      visibleColumns: ['COURSE_AFFILIATE_ID']
    }
  },
  computed: {
    ...mapState('courses', {
      selectedManagers: state => state.selectedManagers,
      courseManagerPagination: state => state.courseManagerPagination
    }),
    ...mapGetters('courses', [
      'managerList'
    ])
  },
  methods: {
    ...mapMutations('courses', [
      'updateSelectedManagers',
      'clearSelectedManagers'
    ]),
    ...mapActions('courses', [
      'fetchManagers'
    ])
  }
}
</script>

<template>
  <div class="">
    <Grid 
      selectable="multiple"
      :data="managerList"
      :pagination="courseManagerPagination"
      :columns="columnOptions"
      :onRequest="fetchManagers"
      :filterable="filterable"
      :onSelect="updateSelectedManagers"
      :selected="selectedManagers"
    >
    <template slot="col-item-active_ind" slot-scope="props">
      <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
        class="label"
        :class="{
            'green' : props.value === 1,
            'red' : props.value === 0
        }">
        {{props.value ? 'Active' : 'Inactive'}}
      </div>
      </template>
    </Grid>
  </div>
</template>

<style>
</style>